import React from 'react';

const PageTitle = () => {
    return (
        <div id="page-title" className="page-title-height d-flex">
            <div className="wrapper">
                <div className="d-flex justify-content-center">
                    <div className="title text-center">
                        <h1>User interface (UI)</h1>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PageTitle;
